import { ReactElement } from 'react'
import { Assignment } from '@mui/icons-material'
import { show } from '@ebay/nice-modal-react'
import { Button } from '../../../../../src/ui-components/forms/Button'
import { VehicleSpecificationDrawer } from '../../../../../src/features/search/VehicleSearch/components/VehicleSpecificationDrawer'
import { usePartsCatalog } from '../../../../../src/store/partsCatalog/PartsCatalog'
import { CatalogNodeType } from '../../../../../src/store/partsCatalog'

const ShowSpecificationsButton = (): ReactElement => {
  const partsCatalog = usePartsCatalog()

  const handleShowSpecification = () => {
    const storeGroupsSelected = partsCatalog.root.getAllDescendants(
      (node) => node.type === CatalogNodeType.GROUP && node.selected
    )

    show(VehicleSpecificationDrawer, { storeGroupsSelected })
  }

  const icon = <Assignment />

  return (
    <Button
      icon={icon}
      text="specifications"
      onClick={handleShowSpecification}
      variant="transparent"
    />
  )
}

export default ShowSpecificationsButton
